// ponytail: date rules copied from snippets/expected-delivery.liquid (Amman line only); share one helper if this goes live.
(() => {
  const ar = document.documentElement.lang === 'ar';
  const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Amman' }));
  const same = (a, b) => a.toDateString() === b.toDateString();
  const tmr = new Date(now); tmr.setDate(tmr.getDate() + 1);
  const name = (d) => same(d, now) ? (ar ? 'اليوم' : 'Today') : same(d, tmr) ? (ar ? 'غداً' : 'Tomorrow')
    : d.toLocaleDateString(ar ? 'ar' : 'en-GB', { weekday: 'long' });
  const CLOSE_FROM = new Date(2026, 9, 28, 10), CLOSE_UNTIL = new Date(2026, 10, 1); // one-off supplier closure, as expected-delivery
  const text = (sd, sat, closed) => {
    const d = new Date(now);
    if (!(sd && now.getHours() < 17)) d.setDate(d.getDate() + 1);
    if (d.getDay() === 5) d.setDate(d.getDate() + 1);
    if (d.getDay() === 6 && sat) d.setDate(d.getDate() + 1);
    const hit = closed && now >= CLOSE_FROM && d < CLOSE_UNTIL;
    if (hit) d.setTime(CLOSE_UNTIL.getTime());
    // same range rule as the product page (before 10am, non-sameday usually still ships today)
    const range = !same(d, now) && now.getHours() < 10 && now.getDay() !== 5 && !(now.getDay() === 6 && sat) && !hit;
    return (ar ? 'عمّان: ' : 'Amman: ') + (range ? name(now) + '–' + name(d) : name(d));
  };
  const fill = () => document.querySelectorAll('.bjo-eta:empty').forEach((el) => {
    el.textContent = text(el.dataset.sd === 'true', el.dataset.sat === 'true', el.dataset.closed === 'true');
  });
  fill();
  new MutationObserver(fill).observe(document.body, { childList: true, subtree: true });
})();
